import { ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT } from '../../../config';
import axiosInstance from '../../../utils/axios';
import { CurrentCashoutResponse } from './online-back-office.type';
import { SingleResponse } from '../../types';

const BASE_URL = ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT;

export class OnlineBackOfficeService {
    static async getTicketCurrentCashout({ accountNumber, ticketCode }: { accountNumber: string; ticketCode: string }) {
        const response = await axiosInstance.get<SingleResponse<CurrentCashoutResponse>>(
            BASE_URL + `/ticket/cashout?accountNumber=${accountNumber}&ticketCode=${ticketCode}`,
        );

        return response.data.item;
    }
}
